var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"w-full":"","flex":"~ col","space-y-2":""}},_vm._l((_vm.questionList),function(item){return _c('div',{key:item.id},[_c('QuestionItem',{attrs:{"data":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }